{
  "title": "Arcane Hacking (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "2nd-level transmutation (technomagic)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (hacking tools)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You gain advantage on all Intelligence checks using hacking tools to break software encryption or online security when using a foreign system.",
    "This spell also allows you to break 2nd level and lower protective spells such as Arcane Lock or Glyph of Warding by making an Intelligence check using hacking tools against the spell save DC of the spell’s caster.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can attempt to counteract a spell set to secure the foreign system if the spell’s level is equal to or less than the level of the spell slot you used."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
